<app-layout-row>
    <app-layout-column [width]="12">
        <app-section-box [disabled]="false" [title]="title()" (titleActionClicked)="remove()" [showTitleAction]="supportsRemove() && mainItemStatus() !== 'Accepted'" [showFooter]="supportsAcceptance()">
            <div body>
                <app-layout-row margin="0">
                    <app-layout-column [width]="12">
                        <ng-content></ng-content>
                    </app-layout-column>
                </app-layout-row>

                <app-layout-row>
                    <app-layout-column [width]="12">
                        @if (createdEntities()?.length > 0) {
                            <p>Created items:</p>
                            <ul>
                                @for (entity of createdEntities(); track $index) {
                                    <li>
                                        <app-link (onClick)="entityClick(entity.Id)">{{entity.Name}}</app-link> 
                                    </li>
                                }
                            </ul>
                        }
                    </app-layout-column>
                </app-layout-row>
            </div>

            <div footer>
                <div class="statusandactions">
                    <p [class]="statusClass()">{{statusText()}}</p>
                    <div class="action-buttons">
                        @if (showReopen()) {<app-link iconClass="dx-icon-revert" class="action-button" (onClick)="reopen()">Reopen for partner input</app-link>} @else {<div></div>}
                        @if (showAccept()) {<app-link iconClass="dx-icon-check" class="action-button" (onClick)="accept()">Accept</app-link>} @else {<div></div>}
                    </div>
                </div>
            </div>
        </app-section-box>
    </app-layout-column>
</app-layout-row>